<template>

  <div class="articlemanagement">
      <Row>
        <Col :xs="24" :sm="24" :md="6" :lg="6" class="data_cart">
          <Card :bordered="false">
            <p slot="title">
              <Icon type="ios-film-outline"></Icon>
              {{langMap.versionData[lang]}}
            </p>
            <a href="#" slot="extra">
                2012-12-23 23:23:30
            </a>
            <div style="padding: 5px">
              <ul>
                <li class="li"><a href="#">{{langMap.mcuFirmwareVersion[lang]}}</a><span>{{version.mcu}}</span></li>
                <li class="li"><a href="#">{{langMap.systemVersion[lang]}}</a><span>{{version.system}}</span></li>
                <li class="li"><a href="#">{{langMap.powerModuleVersion[lang]}}</a><span>{{version.power}}</span></li>
                <li class="li"><a href="#">{{langMap.controlModuleVersion[lang]}}</a><span>{{version.control}}</span></li>
                <li class="li"><a href="#">{{langMap.navigationModuleVersion[lang]}}</a><span>{{version.navigation}}</span></li>
                <li class="li"><a href="#">{{langMap.perceptionModuleVersion[lang]}}</a><span>{{version.perception}}</span></li>
                <li class="li"><a href="#">{{langMap.communicationModuleVersion[lang]}}</a><span>{{version.communication}}</span></li>
                <li class="li"><a href="#">{{langMap.voiceFileVersion[lang]}}</a><span>{{version.voice}}</span></li>
                <li class="li"><a href="#">{{langMap.workAreaVersion[lang]}}</a><span>{{version.workArea}}</span></li>
              </ul>
            </div>
          </Card>
        </Col>
        <Col :xs="24" :sm="24" :md="6" :lg="6" class="data_cart">
          <Card :bordered="false">
            <p slot="title">
              <Icon type="ios-film-outline"></Icon>
              {{langMap.statusData[lang]}}
            </p>
            <a href="#" slot="extra">
              2012-12-23 23:23:30
            </a>
            <div style="padding: 5px">
              <ul>
                <li class="li"><a href="#">{{langMap.outerTemperature[lang]}}</a><span>{{status.outerTemperature}}</span></li>
                <li class="li"><a href="#">{{langMap.windSpeed[lang]}}</a><span>{{status.outerWindSpeed}}</span></li>
                <li class="li"><a href="#">{{langMap.windDirection[lang]}}</a><span>{{status.outerWindDirection}}</span></li>
                <li class="li"><a href="#">{{langMap.altitude[lang]}}</a><span>{{status.altitude}}</span></li>
                <li class="li"><a href="#">{{langMap.innerTemperature[lang]}}</a><span>{{status.innerTemperature}}</span></li>
                <li class="li"><a href="#">{{langMap.axisAngle[lang]}}</a><span>{{status.axisAngle}}</span></li>
                <li class="li"><a href="#">{{langMap.engineSpeed[lang]}}</a><span>{{status.engineSpeed}}</span></li>
                <li class="li"><a href="#">{{langMap.gearRatio[lang]}}</a><span>{{status.gearRatio}}</span></li>
                <li class="li"><a href="#">{{langMap.nominalPower[lang]}}</a><span>{{status.powerNominalCapacity}}</span></li>
                <li class="li"><a href="#">{{langMap.remainingPower[lang]}}</a><span>{{status.stateOfCharge}}</span></li>
                <li class="li"><a href="#">{{langMap.networkType[lang]}}</a><span>{{status.commType}}</span></li>
                <li class="li"><a href="#">{{langMap.networkStatus[lang]}}</a><span>{{status.commStatus}}</span></li>
                <li class="li"><a href="#">{{langMap.upstreamRate[lang]}}</a><span>{{status.commUpstreamRate}}</span></li>
                <li class="li"><a href="#">{{langMap.downstreamRate[lang]}}</a><span>{{status.commDownstreamRate}}</span></li>
                <li class="li"><a href="#">{{langMap.nominalCapacity[lang]}}</a><span>{{status.storageNominalCapacity}}</span></li>
                <li class="li"><a href="#">{{langMap.availableStorage[lang]}}</a><span>{{status.storageResidual}}</span></li>
                <li class="li"><a href="#">{{langMap.controlMode[lang]}}</a><span>{{status.controlMode}}</span></li>
              </ul>
            </div>
          </Card>
        </Col>
        <Col :xs="24" :sm="24" :md="6" :lg="6" class="data_cart">
          <Card :bordered="false">
            <p slot="title">
              <Icon type="ios-film-outline"></Icon>
              {{langMap.movementData[lang]}}
            </p>
            <a href="#" slot="extra">
              2012-12-23 23:23:30
            </a>
            <div style="padding: 5px">
              <ul>
                <li class="li"><a href="#">{{langMap.jd[lang]}}</a><span>{{movement.longitude}}</span></li>
                <li class="li"><a href="#">{{langMap.wd[lang]}}</a><span>{{movement.latitude}}</span></li>
                <li class="li"><a href="#">{{langMap.gpsTime[lang]}}</a><span>{{movement.gpsdatetime}}</span></li>
                <li class="li"><a href="#">{{langMap.directionInfo[lang]}}</a><span>{{movement.direction}}</span></li>
                <li class="li"><a href="#">{{langMap.speed[lang]}}</a><span>{{movement.speed}}</span></li>
                <li class="li"><a href="#">{{langMap.acceleration[lang]}}</a><span>{{movement.acceleration}}</span></li>
              </ul>
            </div>
          </Card>
        </Col>
        <Col :xs="24" :sm="24" :md="6" :lg="6" class="data_cart">
          <Card :bordered="false">
            <p slot="title">
              <Icon type="ios-film-outline"></Icon>
              {{langMap.warningData[lang]}}
            </p>
            <a href="#" slot="extra">
              -
            </a>
            <div style="padding: 5px">
              <ul>
                <li class="li">{{langMap.empty[lang]}}</li>
              </ul>
            </div>
          </Card>
        </Col>
    </Row>

  </div>
</template>

<script>
import api from "../../../api/index.js";
import { sendMsg, contact } from "@/utils/websocket.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      version: {},
      status: {},
      movement: {},
      notice: {}
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  methods: {
    initSocket() {
      contact(2, this.dataCallback);
    },
    dataCallback(data) {
      //console.log(data);
      let ret = JSON.parse(data);
      switch (ret.type) {
        case "fail":
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: ret.data
          });
          break;
        case "status:":
          this.status = ret.data;
          break;
        case "movement:":
          this.movement = ret.data;
          break;
        case "version:":
          this.version = ret.data;
          break;
      }
    }
  },
  created() {
    // this.initSocket();
  }
};
</script>

<style scoped>
.data_cart {
  padding: 10px;
}
.li {
  padding: 10px 0;
}
</style>
